import { View } from "@tarojs/components";
import classNames from "classnames";
import _isString from "lodash/isString";
import _isNumber from "lodash/isNumber";
import * as React from "react";
import { cloneElement, isValidElement } from "react";
import { prefixClassname } from "../styles/index.js";
export default function ImagePlaceholder(props) {
    const { prefix = "placeholder", children } = props;
    if (isValidElement(children)) {
        return cloneElement(children, {
            className: classNames(prefixClassname(`image__${prefix}`), prefixClassname(`image__${prefix}-icon`)),
        });
    }
    if (_isString(children) || _isNumber(children)) {
        return React.createElement(View, { className: prefixClassname(`image__${prefix}`), children: children });
    }
    return React.createElement(React.Fragment, null);
}
